/**
 * Checks if the specified event comes from outside the event-target.
 *
 * @param {Event} e - The event to check.
 * @param {HTMLElement} host - The host element to compare against.
 * @returns {boolean} Returns true if the event comes from outside the host, false otherwise.
 */
export const isOutsideEvent = (e, host) => !e.composedPath().includes(host);
/**
 * Checks if the specified event comes from within the event-target.
 *
 * @param {Event} e - The event to check.
 * @param {HTMLElement} host - The host element to compare against.
 * @returns {boolean} Returns true if the event comes from within the host, false otherwise.
 */
export const isContextEvent = (e, host) => e.composedPath().includes(host);
/**
 * Retrieves the anchor element from the event's composed path.
 */
export const getAnchorElementByEvent = (e) => e.composedPath()
    .find((elem) => elem.tagName === 'A');
/**
 * Retrieves the submit button element from the event's composed path.
 */
export const getSubmitButtonByEvent = (e) => e.composedPath()
    .find((elem) => elem.tagName === 'BUTTON' && elem.getAttribute('type') === 'submit');
//# sourceMappingURL=events.js.map